import ArrowRight from '@assets/icons/arrow-narrow-right.svg';

import { Author } from './Author';
import { Button } from './Button';
import { Card } from './Card';
import { Container } from './Container';
import { Image } from './Image';
import { Title } from './Title';
import { Typography } from './Typography';

interface News {
  title?: Title;
  link?: Route;
}

interface NewsListProps {
  data: News;
  items: Article[];
}

export const NewsList: React.FC<NewsListProps> = ({ data, items }) => (
  <Container>
    <Title variant="center" data={data?.title} />

    <div className="flex flex-wrap justify-center gap-8 py-16">
      {items.map((item) => (
        <Card
          key={item.slug}
          href={`${data.link.href}/${item.slug}`}
          className="flex min-w-[16rem] flex-col overflow-hidden md:min-w-[24rem] md:max-w-[24rem]"
          clickable
          elevated
        >
          <div className="h-[13.5rem] w-full">
            <Image
              src={item.cover_image}
              className="rounded-t-lg object-cover"
            />
          </div>

          <div className="flex flex-col gap-6 p-6">
            <div className="flex flex-col gap-2">
              <Typography variant="h5">{item.title}</Typography>
              <Typography variant="body1" className="text-neutral-500">
                {item.short_description}
              </Typography>
            </div>

            <Author article={item} showReadingTime />
          </div>
        </Card>
      ))}
    </div>

    <div className="flex items-center justify-center ">
      <Button variant="secondary" href={data?.link?.href}>
        <div className="flex gap-2">
          <span>{data?.link?.label}</span>
          <ArrowRight className="h-5 w-5" />
        </div>
      </Button>
    </div>
  </Container>
);
